// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import PostHelloRequestModel from '../../model/post-hello-request-model';
import PostHelloRequestDTO from '../dto/post-hello-request-dto';
import dtoSchema from '../schemas/post-hello-request-schema';

export default abstract class PostHelloRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<PostHelloRequestDTO>) {
    super();
    if (data) {
      this.hello = data.hello;
    }
  }
  /**
  */
  hello?: string;

  static toModel(dto: DeepPartial<PostHelloRequestDTO>): PostHelloRequestModel;
  static toModel(dto: DeepPartial<PostHelloRequestDTO> | undefined | null): PostHelloRequestModel | undefined;
  static toModel(dto: DeepPartial<PostHelloRequestDTO> | undefined | null): PostHelloRequestModel | undefined {
    return dto ? new PostHelloRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<PostHelloRequestModel> | PostHelloRequestModel): PostHelloRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      hello: unwrapped.hello,
    } as PostHelloRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for PostHelloRequestModel, can not map to PostHelloRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
